/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
    bool, string, object, any,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { useDispatch } from 'react-redux';

import SizeChartModal from './SizeChartModal/SizeChartModal';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    weatherWrapper: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        paddingTop: 20,
        [theme.breakpoints.down('md')]: {
            padding: '0px 15px 0px',
        },
        '& li': {
            display: 'flex',
            alignItems: 'center',
            paddingBottom: 5,
            '& span:first-child': {
                marginRight: 9,
                minWidth: 21,
                textAlign: 'center',
            },
            '& p': {
                margin: 0,
            },
            '& img': {
                width: 21,
            },
            '& .water-condition': {
                '& img': {
                    width: 16,
                },
            },
        },
    },
    sizeLink: {
        background: 'transparent',
        border: 'none',
        fontSize: '1rem',
        textDecoration: 'underline',
        lineHeight: '20px',
        cursor: 'pointer',
    },
});
function WeatherConditions({
    weatherData, showGoToPDPLink, pdpLink, goToIcon, classes, sizeChartValues,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const sizeChartToggle = () => {
        dispatch(trackEvent({
            eventName: 'feature_interaction',
            eventCategory: 'Product Page',
            eventAction: 'Size Chart',
            eventLabel: `Size Chart - ${isOpen ? 'Close' : 'Open'}`,
        }));
        setIsOpen(!isOpen);
    };
    const { finalCare, showSizeChart } = weatherData;
    const showAllPlantersSizeChart = sizeChartValues && sizeChartValues === 'Show Size Chart - All Planters';
    const seeSizeChart = (hasSize) => (
        <span className="see-size-chart">
            {hasSize ? '|' : ''}
            {sizeChartValues && (
                <button className={classes.sizeLink} type="submit" onClick={sizeChartToggle} aria-label="See Size Chart">
                    See Size Chart
                </button>
            )}
            <SizeChartModal sizeChartToggle={sizeChartToggle} isOpen={isOpen} showAllPlantersSizeChart={showAllPlantersSizeChart} />
        </span>
    );

    const goToPDP = () => (
        <div className="go-to-pdp">
            <p>
                <a href={pdpLink} aria-label="Go To PDP Page">
                    See Full Details
                </a>
            </p>
        </div>
    );

    if (finalCare && !finalCare.length && !showGoToPDPLink) return null;
    const hasSize = finalCare.find(({ id }) => id === 'size');
    return (
        <ul className={classes.weatherWrapper}>
            {finalCare.map((data) => (
                <>
                    <li key={data.id}>
                        <span className={`${data.id}-condition`}>
                            <img src={data.icon} alt={data?.description} />
                        </span>
                        <div>
                            <p>{data.description} {((showSizeChart && showSizeChart.length) && hasSize && data.id === 'size') ? seeSizeChart(hasSize) : null}</p>
                        </div>
                    </li>
                </>
            ))}
            <li>{seeSizeChart(hasSize)}</li>
            {(showGoToPDPLink) ? <li>{goToPDP()}</li> : null}
        </ul>
    );
}

WeatherConditions.propTypes = {
    weatherData: object.isRequired,
    // sizeChartToggle: func.isRequired,
    showGoToPDPLink: bool.isRequired,
    pdpLink: string.isRequired,
    goToIcon: string.isRequired,
    classes: object.isRequired,
    sizeChartValues: any.isRequired,
};

export default React.memo(withStyles(styles)(WeatherConditions));
